__turbopack_context__.v({
  "slider": "ctgMNW_slider",
});
